// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3teC5","footer":"ModalCreateQualiphyProcedure_footer__afy1z","additionData":"ModalCreateQualiphyProcedure_additionData__1Gn1l"};